<form [formGroup]="form">
  <header [ngClass]="[form.value.enabled ? '' : 'unpublished']">
    <h1 mat-dialog-title>
      @if (!form.value.displayName) {
        <div class="placeholder">
          Prompt profile
        </div>
      }
      {{ form.value.displayName }}
    </h1>
    <aside>
      <!--      <mat-button-toggle-group [value]="documentType" (change)="changeEventMethodName($event)">-->
      @if (!isKyloePrompt) {
        <mat-button-toggle-group class="small-icons-reveal-title"
          hideSingleSelectionIndicator
          [value]="toggleValue"
          (change)="handleLLMRestrictions($event.value)">
          <mat-button-toggle class="danger" [value]="'unpublished'"
            matTooltip="Mark as unpublished for use everywhere"
            matTooltipShowDelay="500" (change)="onSelected('unpublished')">
            <mat-icon fontIcon="public_off"></mat-icon>
            <span class="toggle-name">Unpublished</span>
          </mat-button-toggle>
          <mat-button-toggle [value]="'published'" matTooltip="Mark as published for use in AI Assist"
            matTooltipShowDelay="500" (change)="onSelected('published')">
            <mat-icon fontIcon="public"></mat-icon>
            <span class="toggle-name">Published</span>
          </mat-button-toggle>
          @if (isDataRulesVisible && isFeatureFlagDTAIEnabled) {
            <mat-button-toggle
              [value]="'datarules'"
              matTooltip="Mark as published for use in Kyloe DataTools"
              matTooltipShowDelay="500" (change)="onSelected('datarules')">
              <i class="DataRules-KyloeIcon"></i>
              <span class="toggle-name">Kyloe DataTools</span>
            </mat-button-toggle>
          }
          @if (isFeatureFlagADAIEnabled) {
            <mat-button-toggle [value]="'awesomedocs'"
              matTooltip="Mark as published for use in Kyloe AwesomeDocs"
              matTooltipShowDelay="500" (change)="onSelected('awesomedocs')">
              <mat-icon fontIcon="description" class="material-icons-outlined"></mat-icon>
              <span class="toggle-name">Kyloe AwesomeDocs</span>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      }
      @if (!isNewConfig && !isKyloePrompt) {
        <mat-icon (click)="delete()"
        [matTooltip]="'Delete Prompt'" fontIcon="delete_outline"></mat-icon>
      }
      <mat-icon fontIcon="close" title="Close" (click)="discardLocalChanges()"></mat-icon>
    </aside>
  </header>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [dynamicHeight]="true"
    preserveContent
    [selectedIndex]="isKyloePrompt ? 2 : 0">
    <mat-tab [disabled]="isKyloePrompt" label="Configuration">
      <ng-template mat-tab-label>
        <span [ngClass]="configTabInvalid ? 'invalid-tab' : 'valid-tab'">
          Configuration
          <mat-icon fontIcon="{{ validationIconConfigurationTab }}" class="validation-icon"
          [ngClass]="initialTabState ? 'first-load' : ''"></mat-icon>
        </span>
      </ng-template>
      <div mat-dialog-content>
        <table class="table-striped table-td-border-right">
          <tr>
            <td colspan="3">
              <app-entity-type-picker
                [entitiesToRender]="sortedEntities"
                [form]="form">
              </app-entity-type-picker>
            </td>
          </tr>
          <tr>
            <td colspan="1">
              <mat-label>Prompt name</mat-label>
              <input type="text" formControlName="displayName" placeholder="e.g. Candidate Summary">
            </td>
            <td colspan="2">
              <mat-label>Action</mat-label>
              <input type="text" formControlName="action" placeholder="e.g. Formatted CV">
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <mat-label>Additional context</mat-label>
              <textarea rows="2" formControlName="additionalContext"
              placeholder="Include any additional guidance here e.g. Write the title in bold"></textarea>
            </td>
          </tr>
          <tr>
            <!--              TODO : These can be turned into one component repeated 6 times-->
            <td [ngClass]="{'disabled' : options.role.length === 0}"
              [matTooltip]="options.role.length === 0 ? 'No roles set in the global AI Assist settings' : tooltips.role"
              matTooltipShowDelay="500">
              <mat-label>
                <mat-icon class="format-icons" fontIcon="person"></mat-icon>
                Role
              </mat-label>
              <div class="multiselect-container">
                @if (selected.role.length === 0) {
                  <span
                  class="multi-select-placeholder">Roles...</span>
                }
                <mat-select formControlName="role"
                  (selectionChange)="updateTooltipAndForm('role')"
                  multiple panelClass="with-action-icons-right"
                  class="attachment-dropdown">
                  <mat-select-trigger>
                    @if (selected.role.length > 0) {
                      {{ (selected.role.length > 1 ? (selected.role[0] + '...') : selected.role[0]!) }}
                    }
                    @if (selected.role.length > 1) {
                      <span>
                        (+{{ selected.role.length - 1 }} more)
                      </span>
                    }
                  </mat-select-trigger>
                  @for (role of options.role; track $index) {
                    <mat-option [value]="role">
                      <span class="icon-right">
                        <span class="label">{{ role }}</span>
                        <mat-icon class="mark-default" tabindex="0"
                          matTooltip="Mark as the default role for prompts"
                          matTooltipShowDelay="500"
                          [ngClass]="{'active': role === defaultHighlight.role}"
                          (click)="markAsDefault(role, 'role', $event)"
                          (keydown.enter)="markAsDefault(role, 'role', $event)"
                        (keydown.space)="markAsDefault(role, 'role', $event)">emoji_events</mat-icon>
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </div>
            </td>
            <td [ngClass]="{'disabled' : options.tone.length === 0}"
              [matTooltip]="options.tone.length === 0 ? 'No tones set in the global AI Assist settings' : tooltips.tone"
              matTooltipShowDelay="500">
              <mat-label>
                <mat-icon fontIcon="interpreter_mode"></mat-icon>
                Tone
              </mat-label>
              <div class="multiselect-container">
                @if (selected.tone.length === 0) {
                  <span class="multi-select-placeholder">Select Tone...</span>
                }
                <mat-select formControlName="tone"
                  (selectionChange)="updateTooltipAndForm('tone')"
                  multiple panelClass="with-action-icons-right"
                  class="attachment-dropdown">
                  <mat-select-trigger>
                    @if (selected.tone.length > 0) {
                      {{ (selected.tone.length > 1 ? (selected.tone[0] + '...') : selected.tone[0]!) }}
                    }
                    @if (selected.tone.length > 1) {
                      <span>
                        (+{{ selected.tone.length - 1 }} more)
                      </span>
                    }
                  </mat-select-trigger>
                  @for (tone of options.tone; track $index) {
                    <mat-option [value]="tone">
                      <span class="icon-right">
                        <span class="label">{{ tone }}</span>
                        <mat-icon class="mark-default" tabindex="0"
                          matTooltip="Mark as the default tone for prompts"
                          matTooltipShowDelay="500"
                          [ngClass]="{'active': tone === defaultHighlight.tone}"
                          (click)="markAsDefault(tone, 'tone', $event)"
                          (keydown.enter)="markAsDefault(tone, 'tone', $event)"
                        (keydown.space)="markAsDefault(tone, 'tone', $event)">emoji_events</mat-icon>
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </div>
            </td>
            <td [ngClass]="{'disabled' : options.format.length === 0}"
              [matTooltip]="options.format.length === 0 ? 'No formats set in the global AI Assist settings' : tooltips.format"
              matTooltipShowDelay="500">
              <mat-label>
                <mat-icon fontIcon="description"></mat-icon>
                Format
              </mat-label>
              <div class="multiselect-container">
                @if (selected.format.length === 0) {
                  <span
                  class="multi-select-placeholder">Select Format...</span>
                }
                <mat-select formControlName="format"
                  (selectionChange)="updateTooltipAndForm('format')"
                  multiple panelClass="with-action-icons-right"
                  class="attachment-dropdown"
                  [matTooltip]="promptFormatTooltip" matTooltipShowDelay="500">
                  <mat-select-trigger>
                    @if (selected.format.length > 0) {
                      {{ (selected.format.length > 1 ? (selected.format[0] + '...') : selected.format[0]!) }}
                    }
                    @if (selected.format.length > 1) {
                      <span>
                        (+{{ selected.format.length - 1 }} more)
                      </span>
                    }
                  </mat-select-trigger>
                  @for (format of promptFormatOptions; track $index) {
                    <mat-option [value]="format">
                      <span class="icon-right">
                        <span class="label">{{ format }}</span>
                        <mat-icon class="mark-default" tabindex="0"
                          matTooltip="Mark as the default format for prompts"
                          matTooltipShowDelay="500"
                          [ngClass]="{'active': format === defaultHighlight.format}"
                          (click)="markAsDefault(format, 'format', $event)"
                          (keydown.enter)="markAsDefault(format, 'format', $event)"
                        (keydown.space)="markAsDefault(format, 'format', $event)">emoji_events</mat-icon>
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </div>
            </td>
          </tr>
          <tr class="three-children">
            <td [ngClass]="{'disabled' : options.resultLength.length === 0}"
              [matTooltip]="options.resultLength.length === 0 ? 'No result lengths set in the global AI Assist settings' : tooltips.resultLength"
              matTooltipShowDelay="500">
              <mat-label>
                <mat-icon fontIcon="square_foot"></mat-icon>
                Result length
              </mat-label>
              <div class="multiselect-container">
                @if (selected.resultLength.length === 0) {
                  <span class="multi-select-placeholder">Select Result Length...</span>
                }
                <mat-select formControlName="resultLength"
                  (selectionChange)="updateTooltipAndForm('resultLength')"
                  multiple panelClass="with-action-icons-right"
                  class="attachment-dropdown">
                  <mat-select-trigger>
                    @if (selected.resultLength.length > 0) {
                      {{ (selected.resultLength.length > 1 ? (selected.resultLength[0] + '...') : selected.resultLength[0]!) }}
                    }
                    @if (selected.resultLength.length > 1) {
                      <span>
                        (+{{ selected.resultLength.length - 1 }} more)
                      </span>
                    }
                  </mat-select-trigger>

                  @for (length of options.resultLength; track $index) {
                    <mat-option [value]="length">
                      <span class="icon-right">
                        <span class="label">{{ length }}</span>
                        <mat-icon class="mark-default" tabindex="0"
                          matTooltip="Mark as the default result length for prompts"
                          matTooltipShowDelay="500"
                          [ngClass]="{'active': length === defaultHighlight.resultLength}"
                          (click)="markAsDefault(length, 'resultLength', $event)"
                          (keydown.enter)="markAsDefault(length, 'resultLength', $event)"
                        (keydown.space)="markAsDefault(length, 'resultLength', $event)">emoji_events</mat-icon>
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </div>
            </td>
            <td [ngClass]="{'disabled' : options.explanationDifficulty.length === 0}"
              [matTooltip]="options.explanationDifficulty.length === 0 ? 'No explanation difficulties set in the global AI Assist settings' : tooltips.explanationDifficulty"
              matTooltipShowDelay="500">
              <mat-label>
                <mat-icon fontIcon="landscape"></mat-icon>
                Explanation difficulty
              </mat-label>
              <div class="multiselect-container">
                @if (selected.explanationDifficulty.length === 0) {
                  <span
                  class="multi-select-placeholder">Select Explanation Difficulty...</span>
                }
                <mat-select formControlName="explanationDifficulty"
                  (selectionChange)="updateTooltipAndForm('explanationDifficulty')"
                  multiple panelClass="with-action-icons-right"
                  class="attachment-dropdown">
                  <mat-select-trigger>
                    @if (selected.explanationDifficulty.length > 0) {
                      {{ (selected.explanationDifficulty.length > 1 ? (selected.explanationDifficulty[0] + '...') : selected.explanationDifficulty[0]!) }}
                    }
                    @if (selected.explanationDifficulty.length > 1) {
                      <span>
                        (+{{ selected.explanationDifficulty.length - 1 }} more)
                      </span>
                    }
                  </mat-select-trigger>
                  @for (difficulty of options.explanationDifficulty; track $index) {
                    <mat-option
                      [value]="difficulty">
                      <span class="icon-right">
                        <span class="label">{{ difficulty }}</span>
                        <mat-icon class="mark-default" tabindex="0"
                          matTooltip="Mark as the default explanation difficulty for prompts"
                          matTooltipShowDelay="500"
                          [ngClass]="{'active': difficulty === defaultHighlight.explanationDifficulty}"
                          (click)="markAsDefault(difficulty, 'explanationDifficulty', $event)"
                          (keydown.enter)="markAsDefault(difficulty, 'explanationDifficulty', $event)"
                        (keydown.space)="markAsDefault(difficulty, 'explanationDifficulty', $event)">emoji_events</mat-icon>
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </div>
            </td>
            <td [ngClass]="{'disabled' : options.outputLanguage.length === 0}"
              [matTooltip]="options.outputLanguage.length === 0 ? 'No languages set in the global AI Assist settings' : tooltips.outputLanguage"
              matTooltipShowDelay="500">
              <mat-label>
                <mat-icon fontIcon="language"></mat-icon>
                Output language
              </mat-label>
              <div class="multiselect-container">
                @if (selected.outputLanguage.length === 0) {
                  <span
                  class="multi-select-placeholder">Output languages...</span>
                }
                <mat-select formControlName="outputLanguage"
                  (selectionChange)="updateTooltipAndForm('outputLanguage')"
                  multiple panelClass="with-action-icons-right"
                  class="attachment-dropdown">
                  <mat-select-trigger>
                    @if (selected.outputLanguage.length > 0) {
                      {{ (selected.outputLanguage.length > 1 ? (selected.outputLanguage[0] + '...') : selected.outputLanguage[0]!) }}
                    }
                    @if (selected.outputLanguage.length > 1) {
                      <span>
                        (+{{ selected.outputLanguage.length - 1 }} more)
                      </span>
                    }
                  </mat-select-trigger>
                  @for (language of options.outputLanguage; track $index) {
                    <mat-option [value]="language">
                      <span class="icon-right">
                        <span class="label">{{ language }}</span>
                        <mat-icon class="mark-default material-icons" tabindex="0"
                          matTooltip="Mark as the default language for prompts"
                          matTooltipShowDelay="500"
                          [ngClass]="{'active': language === defaultHighlight.outputLanguage}"
                          (click)="markAsDefault(language, 'outputLanguage', $event)"
                          (keydown.enter)="markAsDefault(language, 'outputLanguage', $event)"
                        (keydown.space)="markAsDefault(language, 'outputLanguage', $event)">emoji_events</mat-icon>
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </div>
            </td>
          </tr>
          <tr class="three-children">
            <td>
              <div>
                <mat-label>Remove bias?</mat-label>
                <mat-checkbox formControlName='removeBias'></mat-checkbox>
              </div>
            </td>
            <td>
              <div>
                <mat-label>Anonymise?</mat-label>
                <mat-checkbox formControlName='anonymise'></mat-checkbox>
              </div>
            </td>
            <td>
              <div>
                <mat-label>Enable Copy button?</mat-label>
                <mat-checkbox formControlName='enableCopyButton'></mat-checkbox>
              </div>
            </td>
          </tr>
          @if (form.get('entityType')?.value !== BullhornEntityType.CLIENT_CORPORATION) {
            <tr class="three-children">
              <td>
                <div>
                  <mat-label>Enable Save as note?</mat-label>
                  <mat-checkbox formControlName='enableSaveAsNote'></mat-checkbox>
                </div>
              </td>
              <td></td>
              <td></td>
            </tr>
          }
          <tr>
            <!-- dumping this in but will become shared library in monorepo -->
            @if (showSaveToFileComponent()) {
              <td colspan="3">
                <mat-expansion-panel class="tablink no-red-indicator" [expanded]="docxEnabled"
                  [disabled]="!docxEnabled" [hideToggle]="true" #docxPanel>
                  <mat-expansion-panel-header class="tabs custom-header" (click)="onPanelHeaderClick($event)">
                    <mat-panel-title>
                      <mat-slide-toggle [checked]="docxEnabled" (change)="onToggleDocxOutput($event)" (click)="$event.stopPropagation()"
                        [matTooltip]="'Allow output in .docx'"
                        [matTooltipPosition]="'above'"
                        [matTooltipShowDelay]="500"
                        (click)="$event.stopPropagation()" >
                        <span class="file-type docx docx-icons"><span>docx</span></span>
                        <span>Enable Word (.docx) output</span>
                      </mat-slide-toggle>
                    </mat-panel-title>
                  <span class="indicator-wrapper">
                    @if (docxEnabled && form.get('fileConfig.fileName')?.invalid) {
                      <mat-icon
                        class="required-icon"
                        fontIcon="error_outlined"
                        matTooltip="Information required"
                        matTooltipShowDelay="500"
                      ></mat-icon>
                    }
                    <span class="mat-expansion-indicator" [class.disabled]="!docxEnabled"></span>
                  </span>
                </mat-expansion-panel-header>
                  <table formGroupName="fileConfig" class="table-striped table-td-border-right table-no-border-bottom">
                    <tr>
                      <td class="file-name-docx">
                        <mat-icon class="docx-icons" fontIcon="drive_file_rename_outline"></mat-icon>
                        <mat-label>File name</mat-label>
                        <span class="input-with-icon">
                          <input
                            #fileNameInput
                            class="search-profiles"
                            matInput
                            formControlName="fileName"
                            placeholder="e.g. Formatted_CV"
                            (keydown)="checkInput($event)"
                            (paste)="preventPaste($event)"
                            matTooltip="Valid characters: A-Z, 0-9, _, -, space, and dynamic tags e.g. [(${bullhorn.Candidate.name})]"
                            matTooltipPosition="above"
                            />
                          </span>
                        </td>
                        <td>
                          <mat-icon fontIcon="insert_drive_file" class="material-icons-outlined docx-icons"></mat-icon>
                          <mat-label>File type</mat-label>
                          <app-document-type-picker #documentTypePicker
                            [placeholderText]="'Enter file type...'"
                            [initialTypeId]="selectedFileType?.id ?? ''"
                            [filterLabel]="FilterLabel.FILE"
                            [namespace]="'bullhorn'"
                            [entityType]="passdownEntityType ? [passdownEntityType.toString()] : []"
                            [autoSelectOnExactMatch]="false"
                            [position]="'initial'"
                            [clearOnSelection]="false"
                            [allowCustomInput]="false"
                            [valid]="form.get('fileConfig.fileType')!.valid"
                            (searchTextChange)="onFileTypeInput($event)"
                            (selected)="addFileType($event)">
                          </app-document-type-picker>
                        </td>
                      </tr>
                    </table>
                  </mat-expansion-panel>
                </td>
              }
            </tr>
            <tr>
              <td colspan="3">
                <mat-label>Description</mat-label>
                <textarea formControlName='description'
                placeholder="e.g. Provides candidate summary"></textarea>
              </td>
            </tr>
          </table>
        </div>
      </mat-tab>
      <mat-tab [disabled]="isKyloePrompt" label="Advanced">
        <ng-template mat-tab-label>
          <span [ngClass]="form.get('LLMs')?.invalid ? 'invalid-tab' : 'valid-tab'">
            Advanced
            <mat-icon fontIcon="{{ validationIconAdvancedTab }}" class="validation-icon"
            [ngClass]="initialTabState ? 'first-load' : ''"></mat-icon>
          </span>
        </ng-template>
        <div mat-dialog-content class="scrollable-container">
          <table class="table-striped table-td-border-right">
            <tr>
              <td>
                <mat-label>Output field name</mat-label>
                <mat-icon fontIcon="info_outline" class="tooltip"
                  [matTooltip]="!isDatarules ? 'This is where the response will be saved in Bullhorn' : 'Kyloe DataTools controls where the response will be saved in Bullhorn'"
                matTooltipShowDelay="500"></mat-icon>
                <input type="text" formControlName="outputFieldName"
                  placeholder="e.g. description, customTextBlock1">
                </td>
                <td rowspan="2" class="source-fields">
                  <mat-label>Source fields</mat-label>
                  <mat-icon fontIcon="info_outline" class="tooltip"
                    matTooltip="Add fields from Bullhorn that you want to add to the context of your prompt e.g. A Candidate's name and other details"
                  matTooltipShowDelay="500"></mat-icon>
                  <app-chips [chips]="getSourceFields()" [placeholder]="'Enter source field ...'"
                    (removeChipEmitter)="removeSourceField($event)">
                  </app-chips>
                </td>
              </tr>
              <tr>
                <td>
                  <mat-label class="with-icon">
                    <mat-icon fontIcon="attach_file"></mat-icon>
                    LLM (Large Language Model)
                  </mat-label>
                  @if (isDatarules) {
                    <mat-icon fontIcon="info_outline" class="tooltip"
                      matTooltip="Only one model can be selected for Kyloe DataTools prompts"
                    matTooltipShowDelay="500"></mat-icon>
                  }
                  <app-llm-select
                    [multiSelect]="!isDatarules"
                    [LLMs]="this.form.get('LLMs')?.value"
                    [LLMList]="LLMList"
                    [defaultLLM]="defaultHighlight.LLMs"
                    (selectionChange)="LLMSelectionChange($event)"
                    (defaultLLMChange)="updateDefaultLLM($event)">
                  </app-llm-select>
                </td>
              </tr>
            </table>
            <mat-accordion class="full-width-accordion">
              @if (form.get('entityType')?.value !== BullhornEntityType.LEAD) {
                <app-filter-panel
                  [filter]="this.form.get('fileFilter')?.value"
                  [filterLabel]="FilterLabel.FILE"
                  [entityType]="passdownEntityType"
                  (filterChange)="onFilterChange($event, FilterLabel.FILE)">
                </app-filter-panel>
              }
              <app-filter-panel [filter]="this.form.get('noteFilter')?.value"
                [filterLabel]="FilterLabel.NOTE"
                [entityType]="passdownEntityType"
                (filterChange)="onFilterChange($event, FilterLabel.NOTE)">
              </app-filter-panel>
              @if (!isIntegrationPrompt()) {
                <mat-expansion-panel class="tablink user-restrictions-panel">
                  <mat-expansion-panel-header class="tabs custom-header">
                    <mat-panel-title>
                      <mat-icon fontIcon="group"></mat-icon>
                      User restrictions
                      <mat-panel-description>Card access based on Bullhorn filters</mat-panel-description>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <app-user-restrictions-panel
                    [userTypeFilterState]="userTypeFilterState"
                    [departmentFilterState]="departmentFilterState"
                    [privateLabelFilterState]="privateLabelFilterState"
                    entityLabel="card">
                  </app-user-restrictions-panel>
                </mat-expansion-panel>
              }
            </mat-accordion>
            <!--{{ form.value | json }} - {{ form.valid | json }}-->
          </div>
        </mat-tab>
        <mat-tab label="Test prompt" [disabled]="form.invalid">
          <ng-template mat-tab-label>
            <span [ngClass]="form.invalid ? 'invalid-tab' : 'valid-tab'"
                [matTooltip]="!loadingResponse && aiResponse !== '' ? 'View response' :
                (loadingResponse ? 'Generating test response' : 'Test your prompt before publishing')">
              <app-ai-stars-generating [generating]="loadingResponse"></app-ai-stars-generating>
              Test prompt
            </span>
          </ng-template>
          <div mat-dialog-content class="scrollable-container">
            <mat-accordion class="full-width-accordion">
              <mat-expansion-panel class="tablink" [expanded]="true">
                <mat-expansion-panel-header class="tabs custom-header">
                  <mat-panel-title>
                    <mat-icon fontIcon="settings_suggest"></mat-icon>
                    Prompt config
                    <mat-panel-description class="list">
                      <span>Testing against</span>
                      @if (form.get('entityType')?.value === BullhornEntityType.JOB_SUBMISSION) {
                        @if (form.get('bullhornEntityId')?.value) {
                          <span>Bullhorn
                            @if (isFirstFieldCandidateId) {
                              {{ entityLabels.Candidate }}
                              ID:
                            }
                            @if (!isFirstFieldCandidateId) {
                              {{ entityLabels.JobOrder }}
                              ID:
                            }
                          {{ form.get('bullhornEntityId')?.value }}</span>
                        }
                        @if (isFirstFieldCandidateId && form.get('jobEntityId')?.value) {
                          <span
                            >{{ entityLabels.JobOrder }}
                          ID: {{ form.get('jobEntityId')?.value }}</span>
                        }
                        @if (!isFirstFieldCandidateId && getSecondaryIdFields().length > 0) {
                          <span
                            >{{ entityLabels.Candidate }}
                          ID(s): {{ getSecondaryIdFields().join(', ') }}</span>
                        }
                      }
                      @if (form.get('entityType')?.value !== BullhornEntityType.JOB_SUBMISSION) {
                        @if (form.get('bullhornEntityId')?.value) {
                          <span>Bullhorn
                            @if (isFirstFieldCandidateId) {
                              {{ labelFromForm }}
                              ID:
                            }
                          {{ form.get('bullhornEntityId')?.value }}</span>
                        }
                      }
                    </mat-panel-description>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="tabcontent">
                  <table id="test-prompt-fields"
                    class="table-striped table-td-border-right table-no-border-bottom full-width">
                    <tr>
                      <td class="source-fields">
                        @if (form.get('entityType')?.value === BullhornEntityType.JOB_SUBMISSION) {
                          <mat-button-toggle-group
                            class="small-icons-only white-icon-selected" formControlName="toggleStatus"
                            hideSingleSelectionIndicator>
                            <mat-button-toggle value="candidateId"
                              matTooltip="{{ entityLabels.Candidate}} ID to test against"
                              matTooltipShowDelay="500"><i class="bhi-candidate"></i>
                            </mat-button-toggle>
                            <mat-button-toggle value="jobOrderId"
                              matTooltip="{{ entityLabels.JobOrder}} ID to test against"
                              matTooltipShowDelay="500"><i class="bhi-job"></i>
                            </mat-button-toggle>
                          </mat-button-toggle-group>
                        }
                        <mat-label>
                          @if (form.get('entityType')?.value === BullhornEntityType.JOB_SUBMISSION) {
                            @if (isFirstFieldCandidateId) {
                              {{ entityLabels.Candidate }}
                              ID
                            }
                            @if (!isFirstFieldCandidateId) {
                              {{ entityLabels.JobOrder }}
                              ID
                            }
                          }
                          @if (form.get('entityType')?.value !== BullhornEntityType.JOB_SUBMISSION) {
                            @if (isFirstFieldCandidateId) {
                              {{ labelFromForm }}ID
                            }
                            <!-- TODO: Can we use a pipe here to split e.g. JobOrder to Job Order -->
                          }
                          to test against
                        </mat-label>
                      </td>
                      <td>
                        <input type="number" placeholder="Enter Bullhorn ID..."
                          formControlName="bullhornEntityId"
                          min="0"
                          (keyup.enter)="sendAiRequest()"/>
                        </td>
                        <!--<td rowspan="2">
                        Attach files from Bullhorn <span class="grey">.docx or .pdf</span>
                      </td>-->
                    </tr>
                    @if (form.get('entityType')?.value === BullhornEntityType.JOB_SUBMISSION) {
                      <tr>
                        <td class="source-fields">
                          <mat-label>
                            With the
                            @if (!isFirstFieldCandidateId) {
                              {{ entityLabels.Candidate }}
                              ID's
                            }
                            @if (isFirstFieldCandidateId) {
                              {{ entityLabels.JobOrder }}ID
                            }
                          </mat-label>
                        </td>
                        <td>
                          @if (isFirstFieldCandidateId) {
                            <input
                              type="number" placeholder="Enter {{ entityLabels.JobOrder }} ID..."
                              formControlName="jobEntityId"
                              min="0"
                              (keyup.enter)="sendAiRequest()"/>
                          }
                          @if (!isFirstFieldCandidateId) {
                            <app-chips
                              id="candidate-ids"
                              [chips]="getSecondaryIdFields()"
                              [maxChips]="MAX_SELECTIONS"
                              [placeholder]="chipTooltipPlaceholder(entityLabels.Candidate)"
                              [tooltip]="chipTooltipPlaceholder(entityLabels.Candidate)"
                              [inputType]="'number'"
                              [disabled]="loadingResponse"
                              (removeChipEmitter)="removeSecondaryIdFields($event)">
                            </app-chips>
                          }
                        </td>
                      </tr>
                    }
                    <tr>
                      <td colspan="3">
                        <div class="info-message">
                          <mat-icon fontIcon="error_outline"></mat-icon>
                          No data from files will be included when testing a prompt
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <button theme="medium" class="test-response full-width"
                          (click)="sendAiRequest()"
                            [matTooltip]="!form.get('bullhornEntityId')?.value ? 'Enter a Bullhorn ID to test against' :
                            (!loadingResponse ? 'View test response' : 'Generating test response')"
                          matTooltipShowDelay="500"
                          [disabled]="isSendButtonDisabled()">
                          <app-ai-stars-generating [generating]="loadingResponse"
                          [disableHover]="true"></app-ai-stars-generating>
                          @if (!loadingResponse) {
                            Test prompt
                          }
                          @if (loadingResponse) {
                            Generating response
                          }
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel class="tablink" [disabled]="aiResponse === ''"
                [expanded]="!loadingResponse && aiResponse.length > 0">
                <mat-expansion-panel-header class="tabs custom-header">
                  <mat-panel-title>
                    <app-ai-stars-generating [generating]="loadingResponse" [disableHover]="true"
                      [matTooltip]="loadingResponse ? 'Generating test response' : 'View test response'"
                    matTooltipShowDelay="500"></app-ai-stars-generating>
                    @if (!loadingResponse) {
                      Response
                    }
                    @if (loadingResponse) {
                      Generating response
                    }
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="tabcontent pendo-ignore">
                  <editor id="result"
                    apiKey="{{ tinyApiKey }}"
                    [init]="{ readonly: true, menubar: false, toolbar: false, plugins: 'autoresize wordcount', max_height: 377 }"
                    formControlName="aiResponse"
                    [outputFormat]="StringUtils.isHtml(aiResponse) ? 'html' : 'text'"
                    [inline]="false"
                  ></editor>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>

    <!--<span style="background-color: lightgreen">{{form.value | json}} | valid={{form.valid}}, dirty={{form.dirty}}</span>-->

    @if (!isKyloePrompt) {
      <section mat-dialog-actions class="footer-btns">
        <button class="danger-btn-hover" (click)="discardLocalChanges($event)" tabindex="0">cancel
        </button>
        <button type="submit" (click)="canSaveCheck()" [disabled]="!allowSave" tabindex="0">save
        </button>
      </section>
    }
